import { Colors } from "@chakra-ui/react";

const blue = {
  50: "#E1FBFF",
  100: "#BBEEF7",
  200: "#93E2F0",
  300: "#6AD6E9",
  400: "#49CBE3",
  500: "#37B2C9",
  600: "#288A9D",
  700: "#1A6270",
  800: "#062A30",
  900: "#001519",
};

const green = {
  50: "#FAFFF4",
  100: "#ECFFD5",
  200: "#DDFEB4",
  300: "#C7F38F",
  400: "#ACD676",
  500: "#91B95F",
  600: "#789C4A",
  700: "#607F37",
  800: "#486227",
  900: "#314519",
};

const grey = {
  50: "#F2F2F8",
  100: "#E0E1E3",
  200: "#BDBEBF",
  300: "#A3A4A6",
  400: "#888A8D",
  500: "#6F7174",
  600: "#57585B",
  700: "#3E3F41",
  800: "#242628",
  900: "#040F0F",
};

const olive = {
  50: "#F6FAE2",
  100: "#E5EDC0",
  200: "#D5DF9C",
  300: "#C4D378",
  400: "#ADC143",
  500: "#9AAD39",
  600: "#78862A",
  700: "#56601D",
  800: "#323A0E",
  900: "#101400",
};

const navy = {
  50: "#DAF8FF",
  100: "#AEE4FF",
  200: "#7ED0FF",
  300: "#4DBEFF",
  400: "#23ABFE",
  500: "#0F91E5",
  600: "#007EC7",
  700: "#005181",
  800: "#003050",
  900: "#001120",
};

const yellow = {
  50: "#FFF8DC",
  100: "#FCE9B0",
  200: "#FADA83",
  300: "#F6CB53",
  400: "#F4BD27",
  500: "#DAA30B",
  600: "#AA7F05",
  700: "#795A01",
  800: "#4A3600",
  900: "#1B1200",
};

const orange = {
  50: "#FFEFDD",
  100: "#FED5B2",
  200: "#F9BA85",
  300: "#F69E55",
  400: "#F27F20",
  500: "#D9690D",
  600: "#AA5208",
  700: "#793904",
  800: "#4A2200",
  900: "#1E0900",
};

const red = {
  50: "#FFF5F5",
  100: "#FED7D7",
  200: "#FEB2B2",
  300: "#FC8181",
  400: "#F56565",
  500: "#E53E3E",
  600: "#C53030",
  700: "#9B2C2C",
  800: "#822727",
  900: "#63171B",
};

const colors: Colors = {
  primary: blue,
  brandBlue: blue["700"],
  brandGreen: green["600"],
  black: "#333333",
  grey,
  gray: grey,
  shadowGray: `${grey["700"]}40`,
  blue,
  yellow,
  navy,
  orange,
  green,
  red,
  olive,
  warningRed: red["600"],
};

export default colors;
